import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";
import {WholesalerDetail} from "../../../models/WholesalerDetail";
const state = {
    // rows: [],
    message: new httpError(),
};
const rows = [];

const getters = {
    getField,
    getCustomerDetailsArray(){
        // use only getters.bigArray in other getters
        return rows;
    }
};

//Mutations
const mutations = {
    setCustomerDetail(state, wholesalerDetail) {
        // state.filteredRows = customerDetails.filter((x) => x.customerNumber);
        this.rows = wholesalerDetail.data;
    },
    addRow(state) {
        if (state.rows.length > 0) {
            state.rows.push(new WholesalerDetail());
        } else {
            state.rows = [new WholesalerDetail()];
        }
    },
    deleteRow(state) {
        // To enable multi-row form handling
        // we make it possible to add new rows.
        state.rows.pop();
    },
    setProgress(state, message) {
        state.message = message;
    },
    removeRow(state, index) {
        state.rows.splice(index, 1);
    },
    updateField,
};

//ACTIONS
const actions = {
    reset({ commit }) {
        commit("setWholesalerDetail", [
            new WholesalerDetail(),
        ]);
    },
    addWholesalerDetail({ state, commit }) {
        return new Promise((resolve) => {
            commit("addRow");
            resolve(state.rows.length - 1);
        });
    },
    async getWholesalerDetails() {
        return new Promise(async (resolve, reject) => {
            try {
                var response = await HTTP.get("Wholesale/GetWholesalers");
                if (response.status !== 200) resolve(response);
                var result = response.data;
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    },
    async listIseekWholesalers() {
        return new Promise(async (resolve, reject) => {
            try {
                var response = await HTTP.get("oms/ListIseekWholesalers");
                if (response.status !== 200) resolve(response);
                var result = response.data;
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    },
    async updateIseekWholesalers({ dispatch }, wholesaler) {
        return new Promise(async (resolve, reject) => {
            try {
                var response = await HTTP.post("oms/UpdateIseekWholesalers", wholesaler);
                if (response.status !== 200) resolve(response);
                var result = response.data;
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    },
    async deleteIseekWholesalers({ dispatch }, wholesaler) {
        return new Promise(async (resolve, reject) => {
            try {
                var response = await HTTP.post("oms/DeleteIseekWholesalers", wholesaler);
                if (response.status !== 200) resolve(response);
                var result = response.data;
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    },
    updateWholesaler ({ dispatch }, wholesaler) {
        return new Promise((resolve, reject) => {
            let response = HTTP.post(
                "Wholesale/UpdateWholesalerEmail",
                wholesaler
            );
            response
                .then((data) => {
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Updated OK", httpStatus: 200 })
                    );
                    resolve(data.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Not saved:" + err.message,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    setMessage({ commit }, message) {
        commit("setProgress", message);
        if (message.httpStatus !== 500)
            setTimeout(() => {
                commit("setProgress", new httpError());
            }, 2000);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
